<script lang="ts">
  import { goto } from '@roxi/routify';
  import { locale } from 'svelte-i18n';
  import { onMount } from 'svelte';

  onMount(() => {
    selectLanguageBasedOnPath();

    $goto('/');
  });

  function selectLanguageBasedOnPath() {
    const { pathname } = window.location;
    if (pathname === '/pt') {
      locale.set('pt');
      localStorage.setItem('lang', 'pt');
    }

    if (pathname === '/en') {
      locale.set('en');
      localStorage.setItem('lang', 'en');
    }
  }
</script>
